<template>
  <a-modal title="请假记录"
           :visible="leaveVisible"
           @cancel="$emit('cancel')"
           @ok="$emit('success')"
           width="80%">
    <record-s-table :recordVisible="leaveVisible"
                    :columns="columns"
                    :expertId="expertId"
                    :readOnly="readOnly"
                    :expert-flag="ExtractExpertFlagEnum.LEAVE[0]" />
  </a-modal>
</template>
<script>
import moment from 'moment'
import { ApplyTypeEnum, ExtractExpertFlagEnum } from '@/epp/expertmain/selectexpertapply/utils/ExpertApplyUtils'
import RecordSTable from '@/epp/expertmain/expertInfo/common/record/RecordSTable.vue'

const columns = [
  {
    title: '活动时间',
    width: '200px',
    dataIndex: 'openDate',
    customRender: (text) => {
      return text && moment(text).format('YYYY年MM月DD日')
    }
  },
  {
    title: '项目名称',
    dataIndex: 'projectName',
    ellipsis: true,
    align: 'left',
  },
  {
    title: '项目编号',
    dataIndex: 'projectCode',
    align: 'center',
  },
  {
    title: '用途',
    customRender: (text, record) => {
      return record.applyType === ApplyTypeEnum.OTHER ? record.applyTypeOther : record.applyTypeText
    }
  },
  {
    title: '请假原因',
    dataIndex: 'expertFlagReason',
    customRender: (text) => {
      return text || '未填写'
    }
  },
]
export default {
  name: 'ExpertAskForLeaveRecord',
  computed: {},
  components: {
    RecordSTable,
  },
  props: {
    expertId: {
      type: String,
      default: ''
    },
    leaveVisible: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      columns,
      ExtractExpertFlagEnum,
    }
  },
  watch: {},
  methods: {}
}
</script>
